<template>
  <div class="profile-list">
    <sc-text
      tag="h3"
      class="profile-list__headline"
      v-if="fields && fields.heading"
      :field="fields.heading"
    />
    <div class="profile-list__content">
      <sc-placeholder name="jss-profile-item" :rendering="rendering" />
    </div>
  </div>
</template>

<script>
import { Text, Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Profile-List',
  components: {
    ScText: Text,
    ScPlaceholder: Placeholder
  },
  props: {
    rendering: {
      type: Object
    },
    fields: {
      type: Object
    }
  }
};
</script>
<style lang="scss" scoped>
.profile-list {
  margin: 2rem 0;

  &__content {
    @include tablet-up {
      display: flex;
      flex-wrap: wrap;
    }
  }

  &__headline {
    color: $blue;
    padding-bottom: 1.5rem;
    border-bottom: solid 0.1rem $divider;
  }
}
</style>
